import { alpha, ButtonProps, Components, lighten, Theme } from '@mui/material'

import Colors from '#/styles/Colors'

const COLORS = [
  'primary',
  'secondary',
  'info',
  'success',
  'warning',
  'error',
  'baby',
  'regular',
] as const

export function OverridedButton(theme: Theme): Components {
  const softStyle = (ownerState: ButtonProps) => {
    if (ownerState.variant !== 'soft') return {}

    const inheritColor = !ownerState.color || ownerState.color === 'inherit'

    if (inheritColor) {
      return {
        backgroundColor: alpha(theme.palette.grey[500], theme.palette.action.activatedOpacity),
        color: theme.palette.text.primary,
      }
    }

    const matched = COLORS.find(c => c === ownerState.color)
    if (!matched) return {}

    const mainColor = Colors.feedback[matched]?.color || theme.palette[matched].main

    return {
      '&.Mui-disabled': {
        backgroundColor: theme.palette.action.disabledBackground,
      },
      'backgroundColor': lighten(mainColor, 0.9),
      'color': mainColor,
    }
  }

  return {
    MuiButton: {
      styleOverrides: {
        contained: {
          color: 'white',
        },
        root: ({ ownerState }: { ownerState: ButtonProps }) => ({
          borderRadius: 100,
          minHeight: 40,
          textTransform: 'none',
          ...softStyle(ownerState),
        }),
        sizeExtended: {
          paddingLeft: 30,
          paddingRight: 30,
        },
        sizeSmall: {
          minHeight: 32,
        },
        sizeTiny: {
          fontSize: '0.8125rem',
          height: 24,
          minHeight: 'unset',
          paddingBottom: theme.spacing(0.25),
          paddingLeft: theme.spacing(1.25),
          paddingRight: theme.spacing(1.25),
          paddingTop: theme.spacing(0.25),
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          '&:not(.MuiFab-root)': {
            boxShadow: 'none !important',
          },
          '&.clearButton > svg': {
            fontSize: 20,
          },
          'textTransform': 'none',
        },
      },
    },
    MuiButtonGroup: {
      styleOverrides: {
        root: {
          borderRadius: 100,
        },
      },
    },
  }
}
